import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const r = ({
  title: l,
  titleId: o,
  ...s
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M548.966 606.925c-2.496 22.336-17.387 36.373-38.037 36.373-20.629 0-35.52-14.037-37.973-36.373l-35.541-310.613c-2.496-23.979 10.731-42.133 33.024-42.133h80.96c22.315 0 35.541 18.155 33.045 42.133zm4.63 122.858c0 23.829-18.133 42.155-42.667 42.155s-42.667-18.325-42.667-42.155v-1.003c0-23.808 18.133-42.176 42.667-42.176s42.667 18.368 42.667 42.176zM512.017 63.991c-247.445 0-448 200.576-448 448s200.555 448.021 448 448.021c247.403 0 448-200.597 448-448.021s-200.597-448-448-448",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = i(r);
export {
  m as default
};
